import { bindActionCreators } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { actions as userActions } from "../slices/auth.slice";
import { actions as utilsActions } from "../slices/utils.slice";
import { actions as usersActions } from "../slices/users.slice";
import { actions as aiActions } from "../slices/ai.slice";
import { actions as treatmentReportSummarySliceActions } from "../slices/treatmentReportSummary.slice";
import { actions as onBoardingActions } from "../slices/onboarding.slice";
import * as paymentSessionActions from "../slices/paymentSession.slice";
import * as entitlementsActions from "../slices/entitlements.slice";
import * as accessControlActions from "../slices/accessControl.slice";
import { useMemo } from "react";

const rootActions = {
  ...userActions,
  ...usersActions,
  ...utilsActions,
  ...aiActions,
  ...treatmentReportSummarySliceActions,
  ...onBoardingActions,
  ...paymentSessionActions,
  ...entitlementsActions,
  ...accessControlActions,
};
export const useActions = () => {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(rootActions, dispatch), [dispatch]);
};
